import React from 'react';
import { css, cx } from 'emotion';
import { observer } from 'mobx-react';
import logoUrl from '../../assets/beautySecundaryLogo.png';
import feefo2026 from '../../assets/feefo-2026.png';
import { salesforceStore } from '../../store/salesforce-store';

const containerStyle = css`
  grid-area: footer;
  background: #1f2933;
  color: white;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  font-family: Lato, sans-serif;
  padding: 7rem 5rem 5rem;
  width: 100%;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 3rem 2rem 2rem;
  }
  @media (min-width: 1441px) {
    padding: 7rem 12rem 5rem;
  }
`;

const imgStyle = css`
  width: 11.25rem;
  height: 4.75rem;
  margin-bottom: 30px;
`;

const sectionStyle = css`
  display: flex;
  flex-direction: column;
`;

const textStyle = css`
  color: white;
  font-family: Lato, sans-serif;
  margin-bottom: 20px;
  line-height: 1.5em;
  font-size: 15px;
  font-weight: 400;
`;

const linkStyle = css`
  color: white;
  opacity: 1;
  text-decoration: none;
`;

const smallTextStyle = css`
  font-size: 0.75rem;
  grid-column: span 3;
  margin-bottom: 0;
`;

const bigTextStyle = css`
  font-size: 28px;
  line-height: 1.4em;
  text-transform: uppercase;
  color: white;
`;

const iconLinkStyle = css`
  line-height: 30px;
  margin-bottom: 20px;
`;

const awardImgStyle = css`
  height: 11.5rem;
  object-fit: contain;
  align-self: end;

  @media (max-width: 768px) {
    align-self: baseline;
  }
`;

const noMarginStyle = css`
  margin-bottom: 0;
`;

const orangeLinkStyle = css`
  color: var(--primarySoft);
  text-decoration: none;
`;

export const Footer = observer(() => {
  const marketingUrl =
    salesforceStore.salesforceOpportunityId || salesforceStore.salesforceLeadId
      ? `${process.env.REACT_APP_MARKETING_FORM}/${salesforceStore.salesforceLeadId ? 'lead' : 'opportunity'}/${
          salesforceStore.salesforceLeadId ? salesforceStore.salesforceLeadId : salesforceStore.salesforceOpportunityId
        }`
      : process.env.REACT_APP_MARKETING_FORM;

  return (
    <footer className={containerStyle}>
      <div className={sectionStyle}>
        <img src={logoUrl} alt="logo" className={cx(imgStyle, 'keep-color')} />
        <p className={textStyle}>Albany Park, Cabot Lane Poole, Dorset BH17 7BX</p>
        <p className={cx(textStyle, noMarginStyle)}>t. 0330 124 0730</p>
        <p className={textStyle}>
          e.{' '}
          <a className={linkStyle} href="mailto:hello@insyncinsurance.co.uk">
            hello@insyncinsurance.co.uk
          </a>
        </p>
      </div>
      <div className={sectionStyle}>
        <p className={cx(textStyle, bigTextStyle)}>CUSTOMER SUPPORT</p>
        <a
          className={cx(textStyle, linkStyle, iconLinkStyle)}
          href={marketingUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Change Marketing Settings
        </a>
        <a
          className={cx(textStyle, linkStyle, iconLinkStyle)}
          target="_blank"
          rel="noopener noreferrer"
          href="https://insyncinsurance.co.uk/wp-content/uploads/insynccentraldocs/centraldocs/B%26B%20Global%20Privacy%20Statement%2010.01.25%201.pdf"
        >
          Data Protection Policy
        </a>
        <a
          className={cx(textStyle, linkStyle, iconLinkStyle)}
          target="_blank"
          rel="noopener noreferrer"
          href="https://insyncinsurance.co.uk/wp-content/uploads/insynccentraldocs/centraldocs/Insync%20TOBA%20v1.4.pdf"
        >
          Terms Of Business
        </a>
      </div>
      <div className={sectionStyle}>
        <img src={feefo2026} alt="award" className={cx(awardImgStyle, 'keep-color')} />
      </div>
      <p className={cx(textStyle, smallTextStyle)}>
        © Insync Insurance Solutions Ltd 2026 All rights reserved. <br /> Insync Insurance Solutions Ltd is authorised &
        regulated by the Financial Conduct Authority where our reference number is 766691. Our registered office is 7th
        Floor, Corn Exchange, 55 Mark Lane, London, EC3R 7NE and we are registered in England under company number
        08810662. Should you have cause to complain, and you are not satisfied with our response to your complaint, you
        may be able to refer it to the Financial Ombudsman Service, which can be contacted as follows: The Financial
        Ombudsman Service Exchange Tower, London, E14 9SR | Tel: 0800 023 4567 or 01200 309516 |{' '}
        <a href="www.financial-ombudsman.org.uk" className={orangeLinkStyle}>
          www.financial-ombudsman.org.uk
        </a>{' '}
        |
        <a
          href="https://insyncinsurance.co.uk/wp-content/uploads/insynccentraldocs/centraldocs/Insync%20TOBA%20v1.4.pdf"
          className={orangeLinkStyle}
          target="_blank"
          rel="noopener noreferrer"
        >
          {' '}
          Terms of Business
        </a>
      </p>
      <p className={cx(textStyle, smallTextStyle)}>
        In requesting a quotation, you agree that we may contact you to discuss your insurance quote and/or your
        specific requirements. This may include communication by phone, email, or SMS. You can withdraw your consent at
        any time by contacting us or using the unsubscribe option provided in our communications. For more details,
        please see our
        <a
          href="https://www.insyncinsurance.co.uk/bitnami/wordpress/wp-content/uploads/docs/Privacy%20Notice.pdf"
          className={orangeLinkStyle}
          target="_blank"
          rel="noopener noreferrer"
        >
          {' '}
          Privacy Notice
        </a>
      </p>
    </footer>
  );
});
